import React from "react";
import Common_Back_Btn from "../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCirclePlus } from "@fortawesome/free-solid-svg-icons";
import SOP_Form from "./sop_Form/SOP_Form";
import SOP_table from "./sop_table/SOP_table";

function SOP() {
  return (
    <>
      <section className="Imperiality Quality_Policy ScopeOfTheLaboratory">
        <div className="back_div">
          <Common_Back_Btn backText="SOP" />
        </div>
        <div className="white_container customer_section">
          {/* Note text */}
          <div className="note_text_holder">
            <p>
            IS Standards are guidelines set by the Bureau of Indian Standards (BIS) to maintain uniformity, quality, and reliability in testing and production. The laboratory adheres to applicable IS standards to ensure accurate results, meet regulatory requirements, and uphold national and customer quality expectations.
            </p>
          </div>
        </div>

        <div className="imperiality_Form_div">
          <SOP_Form />
        </div>

        <div className="imperiality_table_div">
          <SOP_table />
        </div>

        <div className="m-3">
          <div className="add_another_holder">
            <div>
              <span>
                <FontAwesomeIcon icon={faCirclePlus} /> Add Another Document
              </span>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default SOP;
